import TranslationText from '@components/common/TranslationText'
import ProductQAndA from '@components/product/ProductQAndA'
import { useProductQA } from '@hooks/useProductQA'
import React from 'react'
import { Panel } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import './styles.css'

const QA = ({ product }) => {
  const { createQA, loading, questions, users } = useProductQA(product.id, product.platform)
  const handleSubmit = ({ question }: { question: string }) =>
    createQA(product.id, question, product.platform)

  return (
    <Panel eventKey="qa" styleName="panel">
      <Panel.Heading>
        <Panel.Title toggle={true}>
          <FormattedMessage id="product_page.tab_q&a" /> {questions.length > 0 && `(${questions.length})`}
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body collapsible={true}>
        <ProductQAndA
          loading={loading}
          questions={questions}
          users={users}
          onCreate={handleSubmit}
          productId={product.id}
          image={product.cover}
          title={product.titles?.en}
        />
      </Panel.Body>
    </Panel>
  )
}

export default QA
